<template>
  <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarAuditFlowDown",
	data: () => ({
		menuItems: [
			{ title: "Flow-Down Auditor view", link: "/auditflowdown/flowdownauditor" },
			{ title: "Submitter view", link: "/auditflowdown/flowdownsubmitter" },
			{ title: "Flow-Down Audit templates", link: "/auditflowdown/flowdowntemplates" },
		],
		sidebar: false
	})
}
</script>
